import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { Navigate, useParams } from 'react-router-dom';
import { loadCurrentUser } from '~/api/data/users/queries';
import { submitCreateVoiceAgent, submitUpdateVoiceAgent } from '~/api/data/voice/mutations';
import {
  loadTransferDirectoryImportSchema,
  loadVoiceAgent,
  loadVoiceAgentCreateContext,
  loadVoiceAgentLanguageSupport,
  loadVoiceAgents
} from '~/api/data/voice/queries';
import {
  SettingsVoiceAgentCreatePage,
  SettingsVoiceAgentPage,
  SettingsVoicePage
} from '~/pages/settings/voice';

function RedirectOutboundVoiceAgentSettings() {
  const { id } = useParams();
  return <Navigate to={`/app/settings/voice/${id}`} replace />;
}

export const voiceRoutes: RouteObject[] = [
  {
    path: 'voice',
    loader: merge({
      voiceAgents: loadVoiceAgents
    }),
    element: <SettingsVoicePage />,
    children: [
      {
        path: 'new',
        loader: merge({
          agencyUser: loadVoiceAgentCreateContext
        }),
        action: byMethod({
          POST: submitCreateVoiceAgent
        }),
        element: <SettingsVoiceAgentCreatePage />
      }
    ]
  },
  {
    // Legacy outbound settings URL — settings now live at voice/:id for both directions.
    path: 'voice/outbound/:id',
    element: <RedirectOutboundVoiceAgentSettings />
  },
  {
    path: 'voice/:id',
    loader: merge({
      voiceAgent: loadVoiceAgent,
      agencyUser: loadCurrentUser,
      voiceAgentLanguageSupport: loadVoiceAgentLanguageSupport,
      transferDirectoryImportSchema: loadTransferDirectoryImportSchema
    }),
    action: byMethod({
      PUT: submitUpdateVoiceAgent
    }),
    element: <SettingsVoiceAgentPage />
  }
];
